/**
 * The survey's site address: ONE fact, read the same way by every screen in every app.
 *
 * `resolvedAddress` is the source. It is what the quick form, the Notes step and the Sales
 * Engineering step write (survey_setLocation), and the only address the AI report draft, the PDF
 * report and the Drive filing read. `siteInfo.address` is a legacy copy the Engineering form used to
 * edit; nothing on the server reads it, so an address typed there never reached a report. Measured
 * 2026-10-15 (reader key, all 15 surveys): resolvedAddress on 5, siteInfo.address on 1 (a test
 * survey where the two disagreed), the top-level `address` on 0; no survey holds only a legacy copy.
 * The legacy copies are NOT read (decided 2026-10-16, review of #7495): with a fallback, clearing the
 * address (the server deletes resolvedAddress) brought the stale legacy text back on every screen, and
 * no survey depends on a legacy copy alone (0 of 15 measured).
 */
export interface SiteAddressSource {
  readonly resolvedAddress?: { readonly formatted?: string | null } | null;
}

const text = (v: unknown): string | null => (typeof v === 'string' && v.trim() !== '' ? v.trim() : null);

export function surveySiteAddress(survey: SiteAddressSource | null | undefined): string | null {
  if (!survey) return null;
  return text(survey.resolvedAddress?.formatted);
}
